module.exports = __webpack_public_path__ + "img/Live-Casino.a78614f.webp";